import { Box } from '@primer/react';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { hocSinhApi } from '../../api/hocSinhApi';
import Page from '../../components/ui/page';
import { ts_hocsinh_select_parent } from '../../models/request/hocsinh/ts_hocsinh_select_rq';
import { RootState } from '../../state/reducers';
import ThuPhiHocSinh from './ThuPhiHocSinh';
import ThuPhiTabs from './ThuPhiTabs';
import DanhSachHocSinhPage from '../thu-phi/danh-sach-hoc-sinh/DanhSachHocSinhPage';

const HOC_SINH_TAB_ID = "hoc-sinh";

const ThuPhiTabLayout = () => {
    const { selectedId } = useSelector((x: RootState) => x.thuPhiTab);
    const { nam_hoc, dm_coso_id } = useSelector((x: RootState) => x.common);
    const { user_info } = useSelector((x: RootState) => x.auth);
    const showDanhSachHocSinh = !selectedId || selectedId === HOC_SINH_TAB_ID;
    
    const [isLoading, setIsLoading] = useState(false);
    const [dataSourceFilter, setDataSourceFilter] = useState<any[]>([]);
    const [truongFilter, setTruongFilter] = useState(0);
    const [khoiFilter, setKhoiFilter] = useState(0);
    const [heFilter, setHeFilter] = useState(0);

    // Danh sách dm_truong_id được phân quyền cho tài khoản hiện tại
    const allowedTruongIds = useMemo(() => {
        return user_info?.campus?.map((c) => c.id) ?? [];
    }, [user_info]);

    // Chỉ hiển thị học sinh thuộc trường được phân quyền
    const permissionFilteredData = useMemo(() => {
        if (!allowedTruongIds.length) return dataSourceFilter;
        return dataSourceFilter.filter((hs: any) => allowedTruongIds.includes(hs.dm_truong_id));
    }, [dataSourceFilter, allowedTruongIds]);

    const previousContextRef = useRef<{ nam_hoc: any; dm_coso_id: any } | null>(null);

    const handleReloadParents = useCallback(async () => {
        setIsLoading(true);
        const datasend: ts_hocsinh_select_parent = {
            nam_hoc: nam_hoc,
            dm_coso_id: dm_coso_id,
            dm_truong_id: truongFilter,
            dm_khoi_id: khoiFilter,
            dm_he_id: heFilter,
        };
        const res = await hocSinhApi.selectParentInformations(datasend);
        if (res.is_success) {
            setDataSourceFilter(res.data);
        }
        setIsLoading(false);
    }, [nam_hoc, dm_coso_id, truongFilter, khoiFilter, heFilter]);

    useEffect(() => {
        if (!nam_hoc || !dm_coso_id) {
            return;
        }

        const hasData = dataSourceFilter.length > 0;
        const isContextChanged =
            previousContextRef.current?.nam_hoc !== nam_hoc ||
            previousContextRef.current?.dm_coso_id !== dm_coso_id;

        if (!hasData || isContextChanged) {
            handleReloadParents();
        }

        previousContextRef.current = { nam_hoc, dm_coso_id };
    }, [nam_hoc, dm_coso_id, dataSourceFilter.length, handleReloadParents]);
    
    return (
        <Page title='Thu phí'>
            <Box>
                <ThuPhiTabs />
            </Box>
            <Box>
                <Box sx={{ display: showDanhSachHocSinh ? 'block' : 'none' }}>
                    <DanhSachHocSinhPage
                        dataSourceFilter={permissionFilteredData}
                        isLoading={isLoading}
                        onReload={handleReloadParents}
                        truongFilter={truongFilter}
                        khoiFilter={khoiFilter}
                        heFilter={heFilter}
                        onFilterChange={{ setTruongFilter, setKhoiFilter, setHeFilter }}
                    />
                </Box>
                <Box sx={{ display: showDanhSachHocSinh ? 'none' : 'block' }}>
                    <ThuPhiHocSinh selectedTabId={selectedId} />
                </Box>
            </Box>

        </Page>
    );
};

export default ThuPhiTabLayout;